import React, { useState } from 'react'
import { Button } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { PiArrowSquareOut } from 'react-icons/pi'

import IntlMessages from '../../util/IntlMessages'
import { openSupportChat } from '../../util/open-support-chat'
import { openFeatureRequest } from '../../util/open-feature-request'
import { KNOWLEDGE_BASE_URL } from '../../constants'

export const VeeFooterLinks: React.FC = () => {
  const [featureRequestLoading, setFeatureRequestLoading] = useState(false)

  const handleFeatureRequest = () => {
    setFeatureRequestLoading(true)
    openFeatureRequest().finally(() => {
      setFeatureRequestLoading(false)
    })
  }

  return (
    <div className="vee-footer-links">
      <Button type="link" size="small" className="vee-footer-link" disabled={featureRequestLoading} onClick={handleFeatureRequest}>
        <IntlMessages id="veeAssistant.footer.requestFeature" />
        {featureRequestLoading ? <LoadingOutlined aria-hidden /> : <PiArrowSquareOut aria-hidden />}
      </Button>
      <a className="vee-footer-link" href={KNOWLEDGE_BASE_URL} target="_blank" rel="noopener noreferrer">
        <IntlMessages id="veeAssistant.footer.knowledgeBase" />
        <PiArrowSquareOut aria-hidden />
      </a>
      <Button type="link" size="small" className="vee-footer-link" onClick={() => openSupportChat('VEE_ASSISTANT')}>
        <IntlMessages id="app.contactSupport" />
      </Button>
    </div>
  )
}
